import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printCtrlGoods = (user: User, ctrlid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getctrlgoodsconfreport",
		params: {
			userid: user.userId,
			ctrlid,
		},
	});
};

export default printCtrlGoods;
